const Sudoku = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7A2.5 2.5 0 0 1 7 4.5h10A2.5 2.5 0 0 1 19.5 7v10a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 17zM7 5.5A1.5 1.5 0 0 0 5.5 7v2.168h3.667V5.5zm-1.5 8.333v-3.665h3.667v3.665zM5.5 17A1.5 1.5 0 0 0 7 18.5h2.167v-3.664H5.5zm8.336 1.5h-3.67v-3.664h3.67zm0-4.667h-3.67v-3.665h3.67zm4.664-3.665v3.665h-3.664v-3.665zM17 18.5a1.5 1.5 0 0 0 1.5-1.5v-2.164h-3.664V18.5zm0-13A1.5 1.5 0 0 1 18.5 7v2.168h-3.664V5.5zm-3.164 0h-3.67v3.668h3.67z"
      clipRule="evenodd"
    />
  </>
)
export default Sudoku
